import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IInvitation, IInvitations, CreateInvitationInput } from 'types/invitations'

export const invitationsApi = createApi({
  reducerPath: 'invitations',
  baseQuery,
  tagTypes: ['Invitations'],
  endpoints: (builder) => ({
    invitations: builder.query<IInvitations, { tenderId: string }>({
      query: ({ tenderId }) => ({
        url: '/invitations',
        params: {
          tenderId,
        },
      }),
      providesTags: ['Invitations'],
    }),

    invitation: builder.query<IInvitation, IdParams>({
      query: ({ id }) => `/invitations/${id}`,
    }),

    createInvitations: builder.mutation<IInvitation, CreateInvitationInput>({
      query: (body) => ({
        url: '/invitations',
        body,
        method: 'post',
      }),
      invalidatesTags: ['Invitations'],
    }),

    updateInvitation: builder.mutation<IInvitation, Partial<IInvitation>>({
      query: (body) => ({
        url: `/invitations/${body.id}`,
        body,
        method: 'put',
      }),
      invalidatesTags: ['Invitations'],
    }),

    deleteInvitation: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/invitations/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Invitations'],
    }),
  }),
})

export const {
  useInvitationQuery,
  useInvitationsQuery,
  useUpdateInvitationMutation,
  useCreateInvitationsMutation,
  useDeleteInvitationMutation,
} = invitationsApi
